import { mockData } from "Signups/SignupView/mockData";

import FnrFetch4 from "Utilities/FnrFetch/FnrFetch4";

const API = {
  getRefundInfo: (postData) => genericEndpoint("getRefundInfo", postData),
  getSignupListInfo: (signupListID) =>
    new FnrFetch4(
      "/signuplist/" + signupListID + "/adminView",
      null,
      mockData.shouldMock ? mockData.getSignupListInfo : null
    ),
  removeAdditionalName: (signupID, postData) =>
    new FnrFetch4(
      "/signuplist/" + signupID + "/removeAdditionalName",
      postData,
      mockData.shouldMock ? mockData.removeAdditionalName : null
    ),
  removeHouseholdMember: (signupID, postData) =>
    new FnrFetch4(
      `/signuplist/${signupID}/cancelOtherUserSignup`,
      postData,
      mockData.shouldMock ? mockData.removeHouseholdMember : null
    ),
  removeUser: (signupID, postData) =>
    new FnrFetch4(
      `/signuplist/${signupID}/cancelOtherUserSignup`,
      postData,
      mockData.shouldMock ? mockData.removeUser : null
    ),
  cancelAllHouseholdUserSignups: (signupID, postData) =>
    new FnrFetch4(
      `/signuplist/${signupID}/cancelAllHouseholdUserSignups`,
      postData,
      mockData.shouldMock ? mockData.cancelAllHouseholdUserSignups : null
    ),
  /**
   * @param {object} postData
   * @param {number} postData.signupListItemID
   */
  viewItem: (postData) =>
    new FnrFetch4(
      `/signuplist/viewItem`,
      postData,
      mockData.shouldMock ? mockData.viewItem(postData) : null
    ),
};

export default API;

const endpoints = {
  getRefundInfo: {
    url: `/signuplist/getRefundInfo`,
    mockData: mockData.getRefundInfo,
  },
};

const genericEndpoint = (endpoint, postData) => {
  return new FnrFetch4(
    endpoints[endpoint].url,
    postData,
    mockData.shouldMock ? endpoints[endpoint].mockData : null
  );
};
